var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { useCallback, useContext, useEffect, useRef, useState, } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { cloneDeep } from "lodash";
import { Overlay, Popover } from "react-bootstrap";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import "./orderbook.scss";
import SummaryFiltersOrderbook from "../../../components/TableComponent/SummaryFiltersOrderbook";
import MFOrderbookCalendarFilter from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/common/MFOrderbookCalendarFilter/MFOrderbookCalendarFilter";
import ExcelPdfDownload from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/common/ExcelPdfDownload/ExcelPdfDownload";
import SummarySortFilters from "../../../components/TableComponent/SummarySortFilters";
import SearchPanelWithPopupFiltersLabel from "../../../components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import PmsOrdersTable from "./Components/PmsOrdersTable";
// helpers
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { downloadExcelFile } from "@domains/utils/downloadExcelFile";
import { addCommasWithoutEffectingDecimals } from "@domains/utils/numberMethods";
import { FieldNames, FilterSortListOrderBook, } from "../../../constants/constant";
import { EKebebMenuItemsAIFPMS, EOrderBookAifPmsStatus } from "../constant";
import GenericStatus, { EGenericStatusType, } from "@frameworks/shared-library/components/GenericStatus/GenericStatus";
import { EProductIds, ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import RedeemEdit from "./redeem-edit";
import actions from "@mainDi/features/AIF-PMS/actions";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ProductOrderContext } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ProductOrders/ProductOrdersContext";
export var orderBookStatusType = (_a = {},
    _a[EOrderBookAifPmsStatus.CXO_ORDER_REJECTED] = EGenericStatusType.DANGER,
    _a[EOrderBookAifPmsStatus.LOB_HEAD_ORDER_REJECTED] = EGenericStatusType.DANGER,
    _a[EOrderBookAifPmsStatus.ORDER_INPROGRESS] = EGenericStatusType.WARNING,
    _a[EOrderBookAifPmsStatus.ORDER_COMPLETED] = EGenericStatusType.SUCCESS,
    _a[EOrderBookAifPmsStatus.CXO_ORDER_PENDING] = EGenericStatusType.PENDING,
    _a[EOrderBookAifPmsStatus.LOB_HEAD_ORDER_PENDING] = EGenericStatusType.PENDING,
    _a[EOrderBookAifPmsStatus.QC_ORDER_PENDING] = EGenericStatusType.PENDING,
    _a);
var PmsOrders = function (props) {
    var _a;
    //
    var cActions = actions();
    var orderbookRef = useRef(null);
    var _b = __read(useState(null), 2), transactionId = _b[0], setTransactionId = _b[1];
    var _c = __read(useState(""), 2), orderType = _c[0], setOrderType = _c[1];
    var productOrdersContext = useContext(ProductOrderContext);
    var _d = __read(useState({
        CategoryCode: props.subCategoryId,
        page: 1,
        pageSize: 2000,
        FromDate: moment().startOf("month").format("YYYY-MM-DD"),
        ToDate: moment().format("YYYY-MM-DD"),
        OrderBy: "trx_date",
        OrderByDesc: true,
    }), 2), requestPayload = _d[0], setRequestPayload = _d[1];
    var _e = useSelector(function (state) { return state.markets.AifPms; }), filterDetailsAmc = _e.filterDetailsAmc, filterDetailsFund = _e.filterDetailsFund, filterDetailsCategory = _e.filterDetailsCategory, filterListFundName = _e.filterListFundName, filterListAIFFundName = _e.filterListAIFFundName;
    var _f = __read(useState(false), 2), isShowMandatesShimmer = _f[0], setIsShowMandatesShimmer = _f[1];
    var _g = __read(useState({
        conditionType: {
            conditionType: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        returnExpectation: {
            returnExpectation: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        drawdown: {
            drawdown: { label: "Above", value: "Above" },
            conditionValue: "",
        },
        amcNameList: [],
        fundManagerList: [],
        fundNameList: [],
    }), 2), summaryData = _g[0], setSummaryData = _g[1];
    var _h = __read(useState([]), 2), filterLabels = _h[0], setFilterLabels = _h[1];
    var _j = __read(useState(false), 2), openSBViewDetails = _j[0], setOpenSBViewDetails = _j[1];
    var _k = __read(useState(false), 2), isShowFilterPopup = _k[0], setIsShowFilterPopup = _k[1];
    var _l = __read(useState(), 2), selectedValue = _l[0], setSelectedValue = _l[1];
    var _m = __read(useState(false), 2), isAumSize = _m[0], setIsAumSize = _m[1];
    var _o = __read(useState(false), 2), isClear = _o[0], setIsClear = _o[1];
    var _p = __read(useState({}), 2), filters = _p[0], setFilters = _p[1];
    var _q = __read(useState(false), 2), isShowExportPopup = _q[0], setIsShowExportPopup = _q[1];
    var _r = __read(useState(false), 2), excelDownloadLoader = _r[0], setExcelDownloadLoader = _r[1];
    var _s = __read(useState(""), 2), searchText = _s[0], setSearchText = _s[1];
    var _t = __read(useState(false), 2), addBrokerVisible = _t[0], setAddBrokerVisible = _t[1];
    var _u = __read(useState(null), 2), orderBookList = _u[0], setOrderBookList = _u[1];
    var _v = __read(useState(false), 2), isRedeemEditVisible = _v[0], setIsRedeemEditVisible = _v[1];
    var _w = __read(useState({
        isShowPopup: false,
        containerId: "",
    }), 2), tableRowActionPopupConfig = _w[0], setTableRowActionPopupConfig = _w[1];
    var _x = __read(useState([]), 2), tableRowThreeDotActionPopupList = _x[0], setTableRowThreeDotActionPopupList = _x[1];
    var tempData = [
        {
            icon: "edel-icon-page-search",
            text: "View Details",
        },
        // {
        //   icon: "edel-icon-cross",
        //   text: "Cancel Order",
        // },
    ];
    var generateSchemeName = function (values) {
        return (React.createElement("div", { className: "ob-scheme-name-tooltip" },
            React.createElement(GenericSchemeName, { name: String(values[0]), subText1: (props === null || props === void 0 ? void 0 : props.subCategoryId) === Number(ESubProductIds.AIF)
                    ? String(values[1])
                    : String(values[3]), showImage: true, subText2: (props === null || props === void 0 ? void 0 : props.subCategoryId) === Number(ESubProductIds.AIF)
                    ? String(values[2])
                    : "", maxWidth: 335, showTooltip: true })));
    };
    var handleRadioChange = function (e, item) {
        setSelectedValue(item);
    };
    var generateClientName = function (values) {
        return (React.createElement("div", { className: "d-flex flex-column gap-1 client-data-wrapper" },
            React.createElement("span", { className: "txt-grey-shade1 client-name-wrapper DMSanN_15_400", title: values[0] }, values[0] ? values[0] : "-"),
            React.createElement("span", { className: "txt_purple-gray DMSanN_14_300" }, values[1] ? values[1] : "-")));
    };
    var generateStatus = function (statusText, statusType) {
        var resolvedStatusType = orderBookStatusType[statusText];
        return (React.createElement(GenericStatus, { statusText: capitalizeFirstLetter(statusText.replace("order", "")), statusType: resolvedStatusType, parentClassName: "DMsanL_15_300" }));
    };
    var generateDate = function (displayData) {
        var date = moment(displayData);
        var formattedDate = date.format("DD MMM YY");
        var formattedTime = date.format("hh:mm:ss A");
        return displayData ? (React.createElement("div", { className: "d-flex flex-column gap-1 text-left txt-grey-shade1" },
            React.createElement("span", { className: "text-left ms-2 RobotoM_15_400 txt-grey-shade1" }, formattedDate ? formattedDate : "-"),
            React.createElement("span", { className: "text-left txt_purple-gray RobotoM_14_300" }, formattedTime ? formattedTime : "-"))) : ("-");
    };
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.LoginType);
    var handleTableRowThreeDotsClick = function (keys) {
        return function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var updatedTempData;
            return __generator(this, function (_a) {
                e.stopPropagation();
                if (keys[1] && partnerCategory !== ILoginTypeEnum.PARTNER) {
                    tempData.splice(1, 0, {
                        icon: keys[2] || keys[3]
                            ? "edel-icon-editicon-underline"
                            : "edel-icon-add-user",
                        text: keys[2] || keys[3] ? "Modify SB Details" : "Add SB Details",
                    });
                }
                if (keys[4] && partnerCategory !== ILoginTypeEnum.PARTNER) {
                    tempData.push({
                        icon: "edel-icon-editicon-underline",
                        text: "Edit",
                    });
                }
                updatedTempData = tempData.map(function (item) { return (__assign(__assign({}, item), { containerId: "".concat(keys[0]).concat(props.subCategoryId) })); });
                setTableRowThreeDotActionPopupList(updatedTempData);
                setTableRowActionPopupConfig({
                    isShowPopup: true,
                    containerId: "".concat(keys[0]).concat(props.subCategoryId),
                });
                setTransactionId(keys[5] == "T" ? keys[0] : keys[6]);
                setOrderType(keys[5]);
                return [2 /*return*/];
            });
        }); };
    };
    var generateTableRowActionPopup = function (keys) {
        return (React.createElement("span", { id: "".concat(keys[0]).concat(props.subCategoryId), className: "edel-icon-kabab-menu mf-transactions-row-actions-wrapper ".concat(tableRowActionPopupConfig.containerId ===
                "".concat(keys[0]).concat(props.subCategoryId)
                ? "active-menu"
                : ""), onClick: handleTableRowThreeDotsClick(keys) }));
    };
    var generatePmsOrderTableColumns = function () {
        return [
            {
                columnName: "Scheme Name",
                keysForCustomFunction: [
                    "schemeName",
                    "category",
                    "isin_code",
                    "issuer_name",
                ],
                arrows: true,
                type: "string",
                applySorting: true,
                sortKey: "display_name",
                tdCustomFunction: generateSchemeName,
            },
            {
                columnName: "Client Name",
                keysForCustomFunction: ["clientName", "clientPan"],
                type: "string",
                applySorting: false,
                sortKey: "client_name",
                arrows: false,
                tdCustomFunction: generateClientName,
            },
            {
                columnName: "Transaction Type",
                key: "trx_type",
                type: "string",
                applySorting: true,
                sortKey: "trx_type",
                arrows: false,
            },
            {
                columnName: "Placed on",
                key: "orderDateTime",
                type: "Date",
                applySorting: true,
                sortKey: "trx_date",
                arrows: true,
                tdCustomFunction: generateDate,
            },
            {
                columnName: "Amount (₹)",
                key: "amount",
                type: "string",
                applySorting: true,
                arrows: true,
                sortKey: "payment_amt",
                tdCustomFunction: function (key) {
                    var _a;
                    return (React.createElement("div", { className: "d-flex flex-column gap-1 txt_medium-gray ms-3 RobotoM_15_500" }, (_a = addCommasWithoutEffectingDecimals(Number(key))) !== null && _a !== void 0 ? _a : "-"));
                },
            },
            {
                columnName: (React.createElement("div", { className: "d-flex align-items-center gap-1" },
                    "Status ",
                    React.createElement("i", { className: "edel-icon-Information" }))),
                key: "orderStatus",
                key2: "status",
                arrows: false,
                sortKey: "orderStatus",
                type: "string",
                tdCustomFunction: generateStatus,
            },
            {
                columnName: "",
                keysForCustomFunction: [
                    "transactionId",
                    "is_CTA",
                    "sb_code",
                    "passout_percent",
                    "is_editable",
                    "order_type",
                    "orderid",
                ],
                tdCustomFunction: function (keys) { return generateTableRowActionPopup(keys); },
            },
        ];
    };
    var handleAllTransactionsAndSIP_STP_SWP_ThreeDotsMenuItemClick = function (item) {
        switch (item.text) {
            case EKebebMenuItemsAIFPMS.MODIFY:
                aifPmsDi.orderBook.orderbookdetails({
                    CategoryCode: props.subCategoryId,
                    TransactionId: transactionId,
                    ordertype: orderType,
                });
                setOpenSBViewDetails(true);
                setAddBrokerVisible(true);
                break;
            case EKebebMenuItemsAIFPMS.ADD:
                cActions.orderBook.orderbookdetails(null);
                aifPmsDi.orderBook.orderbookdetails({
                    CategoryCode: props.subCategoryId,
                    TransactionId: transactionId,
                    ordertype: orderType,
                });
                setOpenSBViewDetails(true);
                setAddBrokerVisible(true);
                break;
            case EKebebMenuItemsAIFPMS.CANCEL:
                setTableRowActionPopupConfig({
                    isShowPopup: false,
                    containerId: "",
                });
                break;
            case EKebebMenuItemsAIFPMS.EDIT:
                fetchEditRedeemData(transactionId);
                setIsRedeemEditVisible(true);
                break;
            case EKebebMenuItemsAIFPMS.VIEW_DETAILS:
                aifPmsDi.orderBook.orderbookdetails({
                    CategoryCode: props.subCategoryId,
                    TransactionId: transactionId,
                    ordertype: orderType,
                });
                setOpenSBViewDetails(true);
                setAddBrokerVisible(false);
                break;
        }
    };
    var fetchEditRedeemData = function (transactionId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, aifPmsDi.qualityCheck.pendingTransactionsById({
                            categoryCode: props.subCategoryId,
                            trxId: transactionId,
                        })];
                case 1:
                    response = _a.sent();
                    aifPmsDi.qualityCheck.documentList({
                        trxId: transactionId,
                    });
                    aifPmsDi.qualityCheck.folioDetails({
                        categoryCode: props.subCategoryId,
                        schemeId: response.data.schemeId,
                        uccCode: response.data.uccCode,
                        folioNumber: null,
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleAssignHandlerForThreeDotMenuItemClick = function (item) { return function (e) {
        e.stopPropagation();
        handleAllTransactionsAndSIP_STP_SWP_ThreeDotsMenuItemClick(item);
    }; };
    var handleTableRowThreeDotsPopupClose = function (id) {
        setTableRowActionPopupConfig({
            isShowPopup: false,
            containerId: id,
        });
    };
    var removeEmptyObjects = function (obj) {
        if (Array.isArray(obj)) {
            return obj.length === 0 ? undefined : obj.map(removeEmptyObjects);
        }
        if (obj && typeof obj === "object") {
            var cleanedObj = {};
            for (var key in obj) {
                var cleanedValue = removeEmptyObjects(obj[key]);
                if (cleanedValue !== undefined && cleanedValue !== null) {
                    cleanedObj[key] = cleanedValue;
                }
            }
            return Object.keys(cleanedObj).length === 0 ? undefined : cleanedObj;
        }
        return obj;
    };
    var handleSortApplyFilters = function () {
        if (selectedValue) {
            setRequestPayload(__assign(__assign({}, requestPayload), { OrderByDesc: selectedValue.type, OrderBy: selectedValue.value }));
        }
        else {
            setRequestPayload(__assign({}, requestPayload));
        }
        setIsShowFilterPopup(false);
    };
    var handleCancelApplyingPmsFilters = function (isShowPopup) {
        if (isShowPopup === void 0) { isShowPopup = false; }
        if (isShowPopup) {
            fetchFundManager();
        }
        setIsShowFilterPopup(isShowPopup);
    };
    var fetchFundManager = useCallback(function () {
        aifPmsDi.aifPms.getFilterDetails({
            category_code: String(props.subCategoryId),
            fieldName: FieldNames.FUNDMANAGER,
        });
    }, []);
    var handleApplySearchForPms = function (text) {
        if (text) {
            var localFilterData_1 = __assign(__assign({}, requestPayload), { SearchText: text });
            setIsShowMandatesShimmer(true);
            setSearchText(text);
            var orderbooklist = function () { return __awaiter(void 0, void 0, void 0, function () {
                var data, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, aifPmsDi.orderBook.orderbooklist(localFilterData_1)];
                        case 1:
                            data = _a.sent();
                            setOrderBookList(data);
                            setIsShowMandatesShimmer(false);
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            setIsShowMandatesShimmer(false);
                            console.log(err_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            orderbooklist();
        }
        else {
            var localFilterData_2 = __assign({}, requestPayload);
            delete localFilterData_2.SearchText;
            setIsShowMandatesShimmer(true);
            var orderbooklist = function () { return __awaiter(void 0, void 0, void 0, function () {
                var data, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, aifPmsDi.orderBook.orderbooklist(localFilterData_2)];
                        case 1:
                            data = _a.sent();
                            setOrderBookList(data);
                            setIsShowMandatesShimmer(false);
                            return [3 /*break*/, 3];
                        case 2:
                            err_2 = _a.sent();
                            setIsShowMandatesShimmer(false);
                            console.log(err_2);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            orderbooklist();
        }
    };
    var handleUpdatePmsFiltersData = function (data) {
        var filtersObject = __assign(__assign({}, requestPayload), { FromDate: String(data.fromDate), ToDate: String(data.toDate) });
        if (searchText) {
            filtersObject.SearchText = searchText;
        }
        else {
            delete filtersObject.SearchText;
        }
        setRequestPayload(filtersObject);
    };
    var handleDownloadExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isDownloadSuccessful, fileName, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setExcelDownloadLoader(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, aifPmsDi.orderBook.downloadorderbook(__assign({}, requestPayload))];
                case 2:
                    isDownloadSuccessful = _a.sent();
                    fileName = props.subCategoryId === Number(ESubProductIds.AIF)
                        ? "AIF_Orderbook.xls"
                        : "PMS_Orderbook.xls";
                    if (isDownloadSuccessful && (isDownloadSuccessful === null || isDownloadSuccessful === void 0 ? void 0 : isDownloadSuccessful.data)) {
                        downloadExcelFile(isDownloadSuccessful === null || isDownloadSuccessful === void 0 ? void 0 : isDownloadSuccessful.data, fileName);
                        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                            isShow: true,
                            isError: false,
                            msg: "Excel file downloaded successfully!",
                        });
                    }
                    else {
                        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                            isShow: true,
                            isError: true,
                            msg: "Failed to download excel file!",
                        });
                    }
                    setExcelDownloadLoader(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_3 = _a.sent();
                    setExcelDownloadLoader(false);
                    console.log(err_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleApplyFilters = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        var newRequestPayload = cloneDeep(requestPayload);
        newRequestPayload = __assign(__assign({}, newRequestPayload), { aumSize: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.aumSize) || {}, return_Expectations: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.return_Expectations) || {}, drawdown: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.drawdown) || {}, fundManagerList: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.fundManagerList) || "", amcNameList: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.amcNameList) || "", categoryNameList: (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.categoryNameList) || "", fundNameList: newRequestPayload.fundNameList });
        if ((_a = data === null || data === void 0 ? void 0 : data.conditionType) === null || _a === void 0 ? void 0 : _a.conditionValue) {
            newRequestPayload.aumSize = {
                conditionType: ((_d = (_c = (_b = data.conditionType) === null || _b === void 0 ? void 0 : _b.conditionType) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.toUpperCase()) || "",
                conditionValue: ((_e = data.conditionType) === null || _e === void 0 ? void 0 : _e.conditionValue) || "",
            };
        }
        else {
            delete newRequestPayload.aumSize;
        }
        if ((_f = data === null || data === void 0 ? void 0 : data.returnExpectation) === null || _f === void 0 ? void 0 : _f.conditionValue) {
            newRequestPayload.return_Expectations = {
                conditionType: ((_j = (_h = (_g = data.returnExpectation) === null || _g === void 0 ? void 0 : _g.returnExpectation) === null || _h === void 0 ? void 0 : _h.value) === null || _j === void 0 ? void 0 : _j.toUpperCase()) || "",
                conditionValue: ((_k = data.returnExpectation) === null || _k === void 0 ? void 0 : _k.conditionValue) || "",
            };
        }
        else {
            delete newRequestPayload.return_Expectations;
        }
        if (((_l = data === null || data === void 0 ? void 0 : data.fundNameList) === null || _l === void 0 ? void 0 : _l.length) > 0) {
            var filterWithoutAll = data.fundNameList.filter(function (item) { return item !== "all"; });
            newRequestPayload.fundNameList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.fundNameList;
        }
        // Add condition for Drawdown if available
        if ((_m = data === null || data === void 0 ? void 0 : data.drawdown) === null || _m === void 0 ? void 0 : _m.conditionValue) {
            newRequestPayload.drawdown = {
                conditionType: ((_q = (_p = (_o = data.drawdown) === null || _o === void 0 ? void 0 : _o.drawdown) === null || _p === void 0 ? void 0 : _p.value) === null || _q === void 0 ? void 0 : _q.toUpperCase()) || "",
                conditionValue: ((_r = data.drawdown) === null || _r === void 0 ? void 0 : _r.conditionValue) || "",
            };
        }
        else {
            delete newRequestPayload.drawdown;
        }
        // Handle fund manager list
        if (((_s = data === null || data === void 0 ? void 0 : data.fundManagerList) === null || _s === void 0 ? void 0 : _s.length) > 0) {
            newRequestPayload.fundManagerList = data.fundManagerList.join("## ");
        }
        else {
            delete newRequestPayload.fundManagerList;
        }
        // Handle AMC name list
        if (((_t = data === null || data === void 0 ? void 0 : data.amcNameList) === null || _t === void 0 ? void 0 : _t.length) > 0) {
            var filterWithoutAll = data.amcNameList.filter(function (item) { return item !== "all"; });
            newRequestPayload.amcNameList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.amcNameList;
        }
        if (((_u = data === null || data === void 0 ? void 0 : data.categoryNameList) === null || _u === void 0 ? void 0 : _u.length) > 0) {
            var filterWithoutAll = data.categoryNameList.filter(function (item) { return item !== "all"; });
            newRequestPayload.categoryNameList = filterWithoutAll.join(", ");
        }
        else {
            delete newRequestPayload.categoryNameList;
        }
        newRequestPayload = removeEmptyObjects(newRequestPayload);
        setRequestPayload(newRequestPayload);
        setIsShowFilterPopup(false);
        var filterLabel = [];
        if (((_v = newRequestPayload.aumSize) === null || _v === void 0 ? void 0 : _v.conditionType) &&
            ((_w = newRequestPayload.aumSize) === null || _w === void 0 ? void 0 : _w.conditionValue)) {
            var aumLabel = "".concat(newRequestPayload.aumSize.conditionType).concat(newRequestPayload.aumSize.conditionValue);
            filterLabel.push({
                title: aumLabel,
                value: aumLabel,
                typeOfFilter: "aumSize",
            });
        }
        if (((_x = newRequestPayload.return_Expectations) === null || _x === void 0 ? void 0 : _x.conditionType) &&
            ((_y = newRequestPayload.return_Expectations) === null || _y === void 0 ? void 0 : _y.conditionValue)) {
            var returnExpLabel = "".concat(newRequestPayload.return_Expectations.conditionType).concat(newRequestPayload.return_Expectations.conditionValue);
            filterLabel.push({
                title: returnExpLabel,
                value: returnExpLabel,
                typeOfFilter: "return_Expectations",
            });
        }
        if (((_z = newRequestPayload.drawdown) === null || _z === void 0 ? void 0 : _z.conditionType) &&
            ((_0 = newRequestPayload.drawdown) === null || _0 === void 0 ? void 0 : _0.conditionValue)) {
            var drawdownLabel = "".concat(newRequestPayload.drawdown.conditionType).concat(newRequestPayload.drawdown.conditionValue);
            filterLabel.push({
                title: drawdownLabel,
                value: drawdownLabel,
                typeOfFilter: "drawdown",
            });
        }
        var combinedLabelsfundManagerList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.fundManagerList) {
            combinedLabelsfundManagerList = data === null || data === void 0 ? void 0 : data.fundManagerList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "fundManagerList",
            }); });
        }
        var updatedArrayFund = combinedLabelsfundManagerList.map(function (item) {
            var match = filterDetailsFund.find(function (secItem) { return secItem.Name === item.value; });
            if (match) {
                return __assign(__assign({}, item), { title: match.FilterId });
            }
            return item;
        });
        var combinedLabelsFundNameList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.fundNameList) {
            combinedLabelsFundNameList = data === null || data === void 0 ? void 0 : data.fundNameList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "fundNameList",
            }); });
        }
        var updatedArrayFundName = combinedLabelsFundNameList.map(function (item) {
            var fundData = String(props.subCategoryId) === ESubProductIds.AIF
                ? filterListAIFFundName
                : filterListFundName;
            var match = fundData.find(function (secItem) { return secItem.name === item.value; });
            if (match) {
                return __assign(__assign({}, item), { title: match.filterId });
            }
            return item;
        });
        var combinedLabelsamcNameList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.amcNameList) {
            combinedLabelsamcNameList = data === null || data === void 0 ? void 0 : data.amcNameList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "amcNameList",
            }); });
        }
        var updatedArray = combinedLabelsamcNameList.map(function (item) {
            var match = filterDetailsAmc.find(function (secItem) { return secItem.name === item.value; });
            if (match) {
                return __assign(__assign({}, item), { title: match.filterId });
            }
            return item;
        });
        var combinedLabelscategoryNameList = [];
        if (newRequestPayload === null || newRequestPayload === void 0 ? void 0 : newRequestPayload.categoryNameList) {
            combinedLabelscategoryNameList = data === null || data === void 0 ? void 0 : data.categoryNameList.map(function (item) { return ({
                title: item,
                value: item,
                typeOfFilter: "categoryNameList",
            }); });
        }
        var updatedArrayCategory = combinedLabelscategoryNameList.map(function (item) {
            var match = filterDetailsCategory.find(function (secItem) { return secItem.FilterId === item.title; });
            if (match) {
                return __assign(__assign({}, item), { title: match.Name });
            }
            return item;
        });
        var fundData = updatedArrayFundName.filter(function (item) {
            return (item === null || item === void 0 ? void 0 : item.title) !== "all";
        });
        setFilterLabels(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(filterLabel), false), __read(updatedArrayFund), false), __read(updatedArray), false), __read(updatedArrayCategory), false), __read(fundData), false));
    };
    var handleClearAllPmsFilters = function () {
        setIsShowFilterPopup(false);
        setFilterLabels([]);
        setIsClear(true);
        setRequestPayload(__assign(__assign({}, requestPayload), { CategoryCode: props.subCategoryId, page: 1, pageSize: 2000, OrderBy: "trx_date", OrderByDesc: true }));
        setSelectedValue({});
        setSearchText("");
        aifPmsDi.aifPms.getFilterDetails({
            category_code: String(props.subCategoryId),
            fieldName: FieldNames.FUNDMANAGER,
        });
    };
    var handleRefetchOnSuccess = function () {
        setRequestPayload(function (prevPayload) { return (__assign(__assign({}, prevPayload), { CategoryCode: props.subCategoryId, page: 1, pageSize: 2000, OrderBy: "trx_date", OrderByDesc: true, SearchText: (searchText === null || searchText === void 0 ? void 0 : searchText.trim()) ? searchText : "" })); });
    };
    var handleRemoveThroughLabels = function (typeOfFilter, value) {
        var _a, _b, _c, _d, _e, _f, _g;
        setIsAumSize(false);
        var updatedRequestPayload = __assign({}, requestPayload);
        var filterAndUpdate = function (filterLabels, updatedRequestPayload, typeOfFilter, value) {
            var filteredLabels = filterLabels.filter(function (item) {
                if (typeOfFilter === "amcNameList" ||
                    typeOfFilter === "fundManagerList" ||
                    typeOfFilter === "categoryNameList" ||
                    typeOfFilter === "fundNameList") {
                    return item.value !== value;
                }
                else {
                    delete updatedRequestPayload[typeOfFilter];
                    return item.typeOfFilter !== typeOfFilter;
                }
            });
            return { filteredLabels: filteredLabels };
        };
        var result = filterAndUpdate(filterLabels, updatedRequestPayload, typeOfFilter, value);
        var filteredDataAmcNameList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "amcNameList" ? item.value : null;
        });
        var filteredDataFundManList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "fundManagerList" ? item.value : null;
        });
        var filteredDataCategoryList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "categoryNameList" ? item.value : null;
        });
        var filteredDatafundNmaeList = result === null || result === void 0 ? void 0 : result.filteredLabels.map(function (item) {
            return item.typeOfFilter === "fundNameList" ? item.value : null;
        });
        if (typeOfFilter === "fundNameList") {
            var data_1 = result === null || result === void 0 ? void 0 : result.filteredLabels.filter(function (item) { return item.title !== "all"; });
            var filter = void 0;
            var fundData = String(props.subCategoryId) === ESubProductIds.AIF
                ? filterListAIFFundName
                : filterListFundName;
            if (data_1.length < fundData.length) {
                filter = filteredDatafundNmaeList.filter(function (item) { return item !== null && item !== "all"; });
            }
            else {
                filter = filteredDatafundNmaeList.filter(function (item) {
                    return item !== null && item !== "all";
                });
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["fundNameList"] = filter.join(", ");
            }
            else {
                delete updatedRequestPayload["fundNameList"];
            }
        }
        if (typeOfFilter === "amcNameList") {
            var data_2 = result === null || result === void 0 ? void 0 : result.filteredLabels.filter(function (item) { return item.title !== "all"; });
            var filter = void 0;
            if (data_2.length < filterDetailsAmc.length) {
                filter = filteredDataAmcNameList.filter(function (item) { return item !== null && item !== "all"; });
            }
            else {
                filter = filteredDataAmcNameList.filter(function (item) {
                    return item !== null && item !== "all";
                });
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["amcNameList"] = filter.join(", ");
            }
            else {
                delete updatedRequestPayload["amcNameList"];
            }
        }
        if (typeOfFilter === "categoryNameList") {
            var data_3 = result === null || result === void 0 ? void 0 : result.filteredLabels.filter(function (item) { return item.title !== "all"; });
            var filter = void 0;
            if (data_3.length < filterDetailsCategory.length) {
                filter = filteredDataCategoryList.filter(function (item) { return item !== null && item !== "all"; });
            }
            else {
                filter = filteredDataCategoryList.filter(function (item) {
                    return item !== null && item !== "all";
                });
            }
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["categoryNameList"] = filter.join(", ");
            }
            else {
                delete updatedRequestPayload["categoryNameList"];
            }
        }
        if (typeOfFilter === "fundManagerList") {
            var filter = filteredDataFundManList.filter(function (item) {
                return item !== null;
            });
            if ((filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
                updatedRequestPayload["fundManagerList"] = filter.join("## ");
            }
            else {
                delete updatedRequestPayload["fundManagerList"];
            }
        }
        // setRequestPayload(updatedRequestPayload);
        setFilterLabels(result === null || result === void 0 ? void 0 : result.filteredLabels);
        var amcList = (_a = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.amcNameList) === null || _a === void 0 ? void 0 : _a.split(", ").map(String);
        var fundManagerList = (_b = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.fundManagerList) === null || _b === void 0 ? void 0 : _b.split("## ").map(String);
        var categoryNameList = (_c = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.categoryNameList) === null || _c === void 0 ? void 0 : _c.split(", ").map(String);
        var fundNameList = (_d = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.fundNameList) === null || _d === void 0 ? void 0 : _d.split(", ").map(String);
        var conditionData = function (field, defaultValue, fieldSec) {
            var _a;
            var _b, _c;
            if (defaultValue === void 0) { defaultValue = ""; }
            return (_a = {},
                _a[fieldSec] = ((_b = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload[field]) === null || _b === void 0 ? void 0 : _b.conditionType) === "ABOVE"
                    ? { label: "Above", value: "Above" }
                    : { label: "Below", value: "Below" },
                _a.conditionValue = ((_c = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload[field]) === null || _c === void 0 ? void 0 : _c.conditionValue) || defaultValue,
                _a);
        };
        setIsAumSize(true);
        var data = __assign(__assign({}, summaryData), { amcNameList: amcList ? amcList : [], categoryNameList: categoryNameList ? categoryNameList : [], fundManagerList: fundManagerList ? fundManagerList : [], fundNameList: fundNameList ? fundNameList : [], drawdown: ((_e = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.drawdown) === null || _e === void 0 ? void 0 : _e.conditionValue)
                ? conditionData("drawdown", "", "drawdown")
                : {
                    drawdown: { label: "Above", value: "Above" },
                    conditionValue: "",
                }, returnExpectation: ((_f = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.return_Expectations) === null || _f === void 0 ? void 0 : _f.conditionValue)
                ? conditionData("return_Expectations", "", "returnExpectation")
                : {
                    returnExpectation: { label: "Above", value: "Above" },
                    conditionValue: "",
                }, conditionType: ((_g = updatedRequestPayload === null || updatedRequestPayload === void 0 ? void 0 : updatedRequestPayload.aumSize) === null || _g === void 0 ? void 0 : _g.conditionValue)
                ? conditionData("aumSize", "", "conditionType")
                : {
                    conditionType: { label: "Above", value: "Above" },
                    conditionValue: "",
                } });
        var cleanUpdatedRequestPayload = function (field, dataKey) {
            var _a;
            if (!((_a = data[dataKey]) === null || _a === void 0 ? void 0 : _a.conditionValue)) {
                delete updatedRequestPayload[field];
            }
        };
        cleanUpdatedRequestPayload("drawdown", "drawdown");
        cleanUpdatedRequestPayload("return_Expectations", "returnExpectation");
        cleanUpdatedRequestPayload("aumSize", "conditionType");
        setSummaryData(data);
        setRequestPayload(updatedRequestPayload);
    };
    useEffect(function () {
        setIsShowMandatesShimmer(true);
        var orderbooklist = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, aifPmsDi.orderBook.orderbooklist(requestPayload)];
                    case 1:
                        data = _a.sent();
                        setOrderBookList(data);
                        setIsShowMandatesShimmer(false);
                        return [3 /*break*/, 3];
                    case 2:
                        err_4 = _a.sent();
                        setIsShowMandatesShimmer(false);
                        console.log(err_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (props.subCategoryId) {
            orderbooklist();
        }
    }, [requestPayload, props.subCategoryId]);
    useEffect(function () {
        if (productOrdersContext.detailedViewEnabled) {
            if (Number(props.subCategoryId) === Number(ESubProductIds.AIF)) {
                aifPmsDi.aifPms
                    .getFilterDetails({
                    category_code: String(props.subCategoryId),
                    fieldName: FieldNames.CATEGORY,
                })
                    .then(function (res) {
                    aifPmsDi.aifPms
                        .getFilterDetails({
                        category_code: String(props.subCategoryId),
                        fieldName: FieldNames.AMCNAME,
                    })
                        .then(function (res) {
                        if (res) {
                            aifPmsDi.aifPms
                                .getFilterDetails({
                                category_code: String(props.subCategoryId),
                                fieldName: FieldNames.FUNDMANAGER,
                            })
                                .then(function (res) {
                                aifPmsDi.aifPms.getFilterDetails({
                                    category_code: String(props.subCategoryId),
                                    fieldName: FieldNames.FUND_NAME,
                                    orderByDesc: true,
                                    page: 1,
                                    pageSize: 10,
                                });
                            });
                        }
                    })
                        .catch(function () {
                        //
                    });
                });
            }
            else {
                aifPmsDi.aifPms
                    .getFilterDetails({
                    category_code: String(props.subCategoryId),
                    fieldName: FieldNames.AMCNAME,
                })
                    .then(function (res) {
                    if (res) {
                        aifPmsDi.aifPms
                            .getFilterDetails({
                            category_code: String(props.subCategoryId),
                            fieldName: FieldNames.FUNDMANAGER,
                        })
                            .then(function (res) {
                            aifPmsDi.aifPms.getFilterDetails({
                                category_code: String(props.subCategoryId),
                                fieldName: FieldNames.FUND_NAME,
                                orderByDesc: true,
                                page: 1,
                                pageSize: 10,
                            });
                        });
                    }
                })
                    .catch(function () {
                    //
                });
            }
        }
    }, [props.subCategoryId]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "position-relative primary-mutual-fund-order-container d-flex flex-column gap-20 otc-order-book-table order-book-ap ".concat((_a = props.parentClassName) !== null && _a !== void 0 ? _a : ""), ref: orderbookRef },
            React.createElement("div", { className: "d-flex gap-3 align-items-center ".concat(!productOrdersContext.detailedViewEnabled ? "" : "mgt-30") },
                React.createElement("div", { className: "txt_midnight-blue-shade2 ".concat(!productOrdersContext.detailedViewEnabled && "mt-2", " ").concat(productOrdersContext.detailedViewEnabled
                        ? "DMSansNormal_20_400"
                        : "DMSansBold_25_700 mb-20") }, props.subCategoryId === Number(ESubProductIds.AIF)
                    ? "Alternate Investment Funds (AIFs)"
                    : "Portfolio Management Services (PMS)")),
            productOrdersContext.detailedViewEnabled ? (React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "order-book-filter-ap", searchBarParentClassName: "w-400", isShowPopup: isShowFilterPopup, setIsShowPopup: handleCancelApplyingPmsFilters, searchValue: requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.SearchText, isOrderBook: true, applySearchedFilters: function (text) {
                    handleApplySearchForPms(text);
                    setSearchText(text);
                }, clearSearching: props === null || props === void 0 ? void 0 : props.clearSearching, placeholder: "Search by name, category and more", handleClearAllPmsFilters: handleClearAllPmsFilters, iconClassName: "edel-icon-curved-filter", rightSubComponent: React.createElement(React.Fragment, null,
                    React.createElement(MFOrderbookCalendarFilter, { filtersData: {
                            fromDate: requestPayload.FromDate,
                            toDate: requestPayload.ToDate,
                        }, handleApplyCallback: function () { }, handleFilterChangeCallback: handleUpdatePmsFiltersData }),
                    React.createElement(ExcelPdfDownload, { excelDownloadLoader: excelDownloadLoader, handleExcelDownloadCallback: handleDownloadExcel, isShowExportPopup: isShowExportPopup, setIsShowExportPopup: setIsShowExportPopup })), filterComponentInsidePopup: React.createElement(SummaryFiltersOrderbook, { filtersData: filters, handleFilterChangeCallback: function (updatedFilters) {
                        setFilters(updatedFilters);
                    }, handleApplyCallback: handleApplyFilters, handleCancelCallback: function (isShowPopup) {
                        if ((filterLabels === null || filterLabels === void 0 ? void 0 : filterLabels.length) == 0) {
                            setIsClear(true);
                        }
                        handleCancelApplyingPmsFilters(isShowPopup);
                    }, handleClearAllCallback: handleClearAllPmsFilters, allFiltersLoader: false, setSummaryData: setSummaryData, summaryData: summaryData, isShowFilterPopup: isShowFilterPopup, isClear: isClear, isAumSize: isAumSize, filterLabels: filterLabels, setIsAumSize: setIsAumSize, setIsClear: setIsClear, requestPayload: props.subCategoryId }), sortFilterComponentInsidePopup: React.createElement(React.Fragment, null,
                    React.createElement(SummarySortFilters, { handleRadioChange: handleRadioChange, selectedValue: selectedValue, cancelBtnCallback: function () { return setIsShowFilterPopup(false); }, applyBtnCallback: handleSortApplyFilters, filterSortList: FilterSortListOrderBook })), filterLabels: filterLabels, removeFilterThroughLabels: function (typeOfFilter, value) {
                    handleRemoveThroughLabels(typeOfFilter, value);
                }, isFilterHeader: true, delay: 800 })) : null,
            React.createElement(PmsOrdersTable, { productCategoryData: props.productCategoryData, tableData: orderBookList === null || orderBookList === void 0 ? void 0 : orderBookList.data, tableColumns: generatePmsOrderTableColumns(), openSB: openSBViewDetails, viewAllOnClick: function () {
                    productOrdersContext.viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, String(props.subCategoryId));
                }, showShimmer: isShowMandatesShimmer, showViewAll: !productOrdersContext.detailedViewEnabled, setOpenSB: setOpenSBViewDetails, defaultSortingColumnKey: "trx_date", subCategoryId: props.subCategoryId, selectedSortColumnVal: requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.OrderBy, selectedSortVal: (requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.OrderByDesc) ? "DESC" : "ASC", callbackSorted: function (value) {
                    setRequestPayload(__assign(__assign({}, requestPayload), { OrderBy: value === null || value === void 0 ? void 0 : value.sortKey, OrderByDesc: !requestPayload.OrderByDesc }));
                }, errorScreenMessage: props.subCategoryId === Number(ESubProductIds.AIF)
                    ? "You don't seem to have any transactions as of now in AIF."
                    : "You don't seem to have any transactions as of now in PMS.", setAddBrokerVisible: setAddBrokerVisible, addBrokerVisible: addBrokerVisible, onSuccessPassoutAndEmpDetails: handleRefetchOnSuccess }),
            React.createElement(RedeemEdit, { visible: isRedeemEditVisible, setVisible: setIsRedeemEditVisible }),
            tableRowActionPopupConfig.isShowPopup && (React.createElement(Overlay, { show: tableRowActionPopupConfig.isShowPopup, target: document.getElementById(tableRowActionPopupConfig.containerId), rootClose: true, onHide: function () {
                    return handleTableRowThreeDotsPopupClose(tableRowActionPopupConfig.containerId);
                }, placement: "bottom-end", container: orderbookRef },
                React.createElement(Popover, { id: "popover-contained", className: "orderbook-generic-popup-container removePopupTooltipArrow" },
                    React.createElement(Popover.Body, null,
                        React.createElement("div", { className: "table-actions-internal-list-wrapper flex-column flexCenter py-10" }, tableRowThreeDotActionPopupList === null || tableRowThreeDotActionPopupList === void 0 ? void 0 : tableRowThreeDotActionPopupList.map(function (item, index) {
                            return (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: index, tabIndex: 0, onClick: handleAssignHandlerForThreeDotMenuItemClick(item) },
                                React.createElement("i", { className: item.icon }),
                                React.createElement("label", { className: "DMSanN_14_300 txt-han-blue hand_cursor" }, item.text)));
                        })))))))));
};
export default PmsOrders;
